export const sectionIds = {
  grewFast: "why-companies-need-an-os",
  howOsWorks: "how-enerflos-os-works",
  features: "features-and-capabilities",
  solutions: "solutions",
  integratedTools: "integrated-tools-and-apps",
  vsr: "vsr",
  financing: "financing",
  customerPortals: "customer-portals",
  reporting: "reporting",
};
